import React, { Component } from "react";
import { Box } from "@chakra-ui/react";
import "./Tabs.css";

interface ContentItem {
  name: string;
  content: React.ReactNode;
}

interface DatePickerTabsProps {
  items?: ContentItem[];
  selectedTabIndex: number;
  onTabChange: (index: number) => void;
}

export default class DatePickerTabs extends Component<DatePickerTabsProps> {
  render() {
    return (
      <Box className="tab-list">
        {this?.props?.items?.map(({ name, content }, index) => (
          <React.Fragment key={index}>
            {" "}
            <Box
              className="tab"
              _selected={{
                borderBottom: "2px solid #3182CE",
                boxShadow: "none",
                color: "#3182CE",
              }}
              _focus={{ boxShadow: "none" }}
              _active={{ boxShadow: "none" }}
            >
              {name}
            </Box>
            <Box className="tab-time">{content}</Box>
          </React.Fragment>
        ))}
      </Box>
    );
  }
}
